import { Fragment } from "react";

import Slider from "react-slick";

import UserImg from "../../../assets/images/user.png";

import "./TestimonialsSec.css";
import { useStaticPageContent } from "../../../hooks/useStaticPageContent";
import { staticContentDefaults } from "../../../data/staticContentDefaults";
import { getStaticContentImage } from "../../../utils/staticContentImages";
import CmsRichText from "../../common/CmsRichText";
import { mergeSplitHeadingHtml } from "../../../utils/cmsHeadingUtils";

const TestimonialsSec = () => {
  const pageContent = useStaticPageContent("shared");
  const content =
    pageContent?.testimonials || staticContentDefaults.shared.testimonials;
  const items = content?.items?.length
    ? content.items
    : staticContentDefaults.shared.testimonials.items;

  const settings = {
    dots: true, // Enable indicators
    slidesToShow: 1,
    infinite: true,
    speed: 1900,

    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1023, // Small screens
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 991, // Small screens
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 767, // Small screens
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 499, // Small screens
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <Fragment>
      <div >
        <div className="container-fluid my-container">
          <div className="row">
            <div className="col-12 col-lg-12">
              <div className="heading-sec new">
                <h2>
                  <CmsRichText as="span" value={mergeSplitHeadingHtml(content)} />
                </h2>
                <p>
                  <CmsRichText as="span" value={content.subtext} />
                </p>
              </div>
            </div>
            <Slider {...settings}>
              {items.map((item, index) => (
                <div className="carousel-item active" key={`${item.author}-${index}`}>
                  <div className="slider-sec">
                    <div className="slider-inner">
                      <img
                        src={getStaticContentImage(item.avatar, UserImg)}
                      />
                      <div className="slider-content">
                        <p>
                          <CmsRichText as="span" value={item.quote} />
                        </p>
                        <ul>
                          {Array.from({ length: item.rating || 5 }).map(
                            (_, starIndex) => (
                              <li key={starIndex}>
                                <i className="fa fa-star"></i>
                              </li>
                            )
                          )}
                        </ul>
                        <h3>{item.author}</h3>
                        {item.company ? <p>{item.company}</p> : null}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default TestimonialsSec;
